<template>
	<div class="search-engine">
		<!-- Zadavani vyhledavani mesta -->
		<div class="search-engine-first-row">
			<CitySearch
				@citySelected="citySelected"
			/>

			<StreetSearch v-if="showStreet"
				:cityName="selectedCity"
				@streetSelect="streetSelected"
				@streetAddingDraft="draftingStreet"
				@streetAddingStart="streetAddingStart"
				ref="streetSearch"
			/>

			<AddressSearch v-if="showAddresses"
				:cityName="selectedCity"
				:streetName="selectedStreet"
				@addressSelect="addressSelected"
				ref="addressSearch"
			/>
		</div>


		<!-- Zobrazovani adresniho mista -->
		<div class="search-engine-second-row" v-if="selectedAddress !== null && myData !== null">
			<!-- Adress info -->
			<AddressInfo
				:selectedAddress="selectedAddress"
				@newBezdratMesta="updateBezdratMesta"
				@newpoznamkaAdresy="updatePoznamkaAdresy"
				:bezdratMesta="bezdratMesta"
				:poznamkaAdresy="poznamkaAdresy"
			/>

			<!-- Data cetinu (objekt obsahuje i prdukty) -->
			<!--<AddressCetinInfo v-if="(! selectedAddress.created)"
				:cetinToBeAvailable="myData.cetinToBeAvailable"
				:finalAttributy="myData.finalAttributy"
				:finalNutnosti="myData.finalNutnosti"
				:isBonding="myData.isBonding"
			/>-->

			<!--<div v-else-if="! fetchingProducts"> Nejsou k dispozici cetin data, pravdepodobne protoze ulice byla umele vytvorena a neni platny RUIAN kod.</div>-->

			<!-- Produkty z DB -->
			<div class="container-fluid text-left mt-2">
				<span class="products-title"> Produkty: </span>
				<div v-if="! fetchingProducts" class="address-products">
					<div class="product-adding-false" v-if="! productAdding" @click="addingProductToggle">
						+
					</div>
					<Product v-else :product="newProduct" :newing="true" :adresniMisto="selectedAddress.adresni_misto" @refetch="refetchProducts" @stopCreating="addingProductToggle" />
					<Product v-for="product of products" :key="product.index" :product="product" @refetch="refetchProducts"/>
				</div>
				<div v-else class="address-products-fetching"> Načítám produkty </div>
			</div>
		</div>
		<div v-else-if="fetchingProducts">
			<circle-spin :loading="fetchingProducts"></circle-spin>
		</div>


	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import CitySearch from '@/components/engine/citySearch'
import StreetSearch from '@/components/engine/streetSearch'
import AddressSearch from '@/components/engine/addressSearch'
import Product from '@/components/verifier/Product'
import AddressInfo from '@/components/verifier/AddressInfo'
import AddressCetinInfo from '@/components/verifier/AddressCetinInfo'

import { mapGetters } from 'vuex'

export default {
	name: 'SearchEngine',

	components: {
		CitySearch,
		StreetSearch,
		AddressSearch,
		Product,
		AddressInfo,
		AddressCetinInfo,
	},

	data () {
		return {
			cityName: null,
			cityPsc: null,
			city: 'hledej',
			cityFound: false,
			cityDistricts: [],
			selectedDistrict: null,
			cityStreetToSearch: null,
			addresses: {},
			currentlyOpen: null,
			products: [],
			newAddress: {
				name: null,
				addresses: [{
					number_domovni: null,
					number_orientacni: null,
					index: 'temp',
				}]
			},
			noveCisloDomovni: null,
			noveCisloOrientacni: null,
			showNewBool: false,
			addNewOneBool: true,
			savingNewAdresniMisto: false,
			reloadingNewAdresniMisto: false,
			savingNewAddress: false,
			streetTexts: {},
			holdText: null,
			selectedStreet: null,
			selectedCity: null,
			showStreet: false,
			showAddresses: false,
			selectedAddress: null,
			fetchingProducts: false,
			cetin: null,
			poznamkaAdresy: null,
			productAdding: false,
			newProduct: {},
			chybneHlasky: [],
			newPoznamkaAdresy: null,
			bezdratMesta: null,
			newProduct: {
                index: '',
                adresni_misto: '',
                spolecnost: '',
                cena: '',
                rychlost: '',
                priorita: '',
                poznamka: '',
                show: true,
                instalace: '',
                bonusy: '',
                technologie: '',
			},
			myData: null,
		}
	},

	methods: {
		...mapGetters([
            'getPowers',
            'getUserObject',
		]),

		updateBezdratMesta (to) {
			this.bezdratMesta = to
		},

		updatePoznamkaAdresy (to) {
			this.poznamkaAdresy = to
		},

		async refetchProducts() {
			this.fetchingProducts = true
            const user = this.getUserObject()

			const products = await AdditionsService.fetchProducts(this.selectedAddress.adresni_misto, user.name)
			// this.cetin = products.data.cetin[0]
			this.poznamkaAdresy = products.data.poznamka
			this.products = products.data.hold
			this.fetchingProducts = false
		},

		toggleNewing () {
			this.newing = false
		},

		async deleteProduct (index) {
			const returned = await AdditionsService.deleteProduct(index)
			if (returned.data) {
				this.fetchingProducts = true
            	const user = this.getUserObject()

				const products = await AdditionsService.fetchProducts(this.selectedAddress.adresni_misto, user.name)
				//this.cetin = products.data.cetin[0]
				this.bezdratMesta = products.data.bezdrat
				this.poznamkaAdresy = products.data.poznamka
				this.products = products.data.hold
				this.fetchingProducts = false
			}
		},

		async addNewProduct() {
			this.chybneHlasky = []
			if (! this.newProduct) {
				this.chybneHlasky.push('wtf')
			}
			if (! this.newProduct.hasOwnProperty('cena') || this.newProduct.cena === '') {
				this.chybneHlasky.push('Spatna cena')
			}
			if (! this.newProduct.hasOwnProperty('spolecnost') || this.newProduct.spolecnost === '') {
				this.chybneHlasky.push('Spatna spolecnost')
			}
			const prio = parseInt(this.newProduct.priorita)

			if (! this.newProduct.hasOwnProperty('priorita') || this.newProduct.priorita === '' || isNaN(prio)) {
				this.chybneHlasky.push('Spatna priorita')
			}
			this.newProduct.priorita = prio

			if (! this.newProduct.hasOwnProperty('rychlost') || this.newProduct.rychlost === '' ) {
				this.chybneHlasky.push('Spatna rychlost')
			}

			if (this.chybneHlasky.length) {
				return
			}

			const products = await AdditionsService.addNewProduct(this.selectedAddress.adresni_misto, this.newProduct)
			this.productAdding = false
			if (products.data) {
				this.fetchingProducts = true

				const products = await AdditionsService.fetchProducts(this.selectedAddress.adresni_misto)
				// this.cetin = products.data.cetin[0]
				this.bezdratMesta = products.data.bezdrat
				this.poznamkaAdresy = products.data.poznamka
				this.products = products.data.hold
				this.fetchingProducts = false
			}
		},

		addingProductToggle () {
			if (this.productAdding) {
				this.newProduct = {}
			}
			this.productAdding = ! this.productAdding
		},

		streetAddingStart () {
			this.showAddresses = false

		},

		// TODO can i delete this?
		draftingStreet (draftName) {
		},

		citySelected (c) {
			if (this.selectedCity === c) {
				return
			}

			const holdSelectedCity = this.selectedCity
			this.selectedCity = c
			this.showStreet = true

			if (holdSelectedCity !== c && this.$refs.hasOwnProperty('streetSearch')) {
				this.selectedStreet = null
				this.$refs.streetSearch.setStreetNames(this.selectedCity)
			}

			if (holdSelectedCity !== c && this.$refs.hasOwnProperty('addressSearch')) {
				this.selectedAddress = null
				this.products = []
				this.showAddresses = false
			}
		},

		streetSelected (s) {
			if (this.selectedStreet === s) {
				return
			}

			const holdSelectedStreet = this.selectedStreet

			this.selectedStreet = s
			this.showAddresses = true

			this.$forceUpdate()

			let done = false
			this.selectedAddress = null

			if (holdSelectedStreet !== s && this.$refs.hasOwnProperty('addressSearch')) {
				done = true
				this.$refs.addressSearch.setAddressNames(this.selectedCity, this.selectedStreet)
			}
		},

		async addressSelected (a) {
			this.selectedAddress = a
			this.productAdding = false
			this.fetchingProducts = true
			this.myData = null
            const user = this.getUserObject()
			const products = await AdditionsService.fetchProducts(this.selectedAddress.adresni_misto, user.name)
			this.myData = products.data
			// this.cetin = products.data.cetin[0]
			this.bezdratMesta = products.data.bezdrat
			this.poznamkaAdresy = products.data.poznamka
			this.products = products.data.hold

			this.fetchingProducts = false
		},

		async saveAddText(add) {
			const adresniMistoTextSaved = await AdditionsService.adresniMistoTextAdd(add)
		},

		async saveStreetText (text, i) {
			const newStreetTextSaved = await AdditionsService.addStreetText(text, i, this.cityName)
			this.texts[i] = text
			this.$forceUpdate()
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.search-engine
	display flex
	flex-direction column

.search-engine-first-row
	display flex
	flex-direction row

.search-engine-second-row
	display flex
	flex-direction column
	margin-top 10px
	padding 10px

.products-title
	font-size 24px
	text-align left
	color gray
	margin-top 30px

.address-products
	display flex
	flex-direction row
	justify-content left
	margin-top 10px
	flex-wrap wrap

.product-adding-false
	width 200px
	height 243px
	line-height 243px
	font-size 28px
	text-align center
	background-color white
	cursor pointer
	margin-top 10px

.address-products-fetching
	height 307px

@media (max-width 1000px)
	.search-engine-first-row
		display flex
		flex-direction column
		place-content center

</style>



// WEBPACK FOOTER //
// src/components/verifier/SearchEngine.vue